module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_8017.4dc8c0a8.png";